import { useResetRecoilState } from 'recoil';
import { CherreState } from '../recoil';
import { useResolveNode } from './useRecoilScope';

export const useCherreResetState = <T>(node: CherreState<T>) => {
  return useResetRecoilState(useResolveNode(node));
};
